module.exports = __webpack_public_path__ + "img/member.d3595ddf.jpg";